import $ from 'jquery';

export default class OverlayController {
    constructor() {
        this.MODALS_SELECTOR = '.modal.fade';
        this.TRIGGER_SELECTOR = '.sos-overlay-trigger';
        this.NBA_SELECTOR = '.navbar .sos-nba';
        this.NBA_SELECTOR_FLOATING = '#footer-nba-content';

        this.initNBAContainers();
        this.createModalsFromNbas();
        this.registerClickEvents();
        this.positionModals();
    }

    initNBAContainers() {
        $.each(nbaConfig.buttons, (index, value) => { // eslint-disable-line no-undef
            if (value.position === 'Footer') { // is element postioned inside footer container
                if (!$(this.NBA_SELECTOR_FLOATING).length) { // footer container not already exists
                    $('body').append('<div id="footer-nba"><div id="footer-nba-content"></div></div>'); // append footer container to body
                }
            }
        });
    }

    createModalsFromNbas() {
        $.each(nbaConfig.buttons, (index, value) => { // eslint-disable-line no-undef
            let nbaButton;
            if (value.overlay) {
                nbaButton = `<div data-url='${value.url.toLowerCase()}' class='sos-overlay-trigger btn nba-btn ${
                    value.color ? value.color : ''} ${
                    value.icon ? 'nba-hasimage' : ''}'>`;
                if (typeof value.icon !== 'undefined') nbaButton += `<img class='nba-icon' src='${value.icon}'>`;
                nbaButton += `${value.text}</div>`;
            }
            else {
                nbaButton = `<a href='${value.url}' class='btn nba-btn ${
                    value.color ? value.color : ''} ${
                    value.icon ? 'nba-hasimage' : ''}'>`;
                if (typeof value.icon !== 'undefined') nbaButton += `<img class='nba-icon' src='${value.icon}'>`;
                nbaButton += `${value.text}</a>`;
            }

            if (value.position === 'Footer') {
                $(this.NBA_SELECTOR_FLOATING).append(nbaButton);
            }
            else {
                $(this.NBA_SELECTOR).append(nbaButton);
            }
        });
    }

    registerClickEvents() {
        $(this.TRIGGER_SELECTOR).click((event) => {
            event.preventDefault();
            const dataUrl = event.target.dataset.url;
            $(`.modal[data-url="${dataUrl}"]`).first().modal({ show: true });
        });
    }

    positionModals() {
        // ensure all modals are 1st level child of body
        $(this.MODALS_SELECTOR).appendTo(document.body);
    }

    static init() {
        $(document).ready(() => {
            new OverlayController(); // eslint-disable-line no-new
        });
    }
}
